import React from "react";
import FileExportIcon from "../../../components/FileExport/FileExportIcon";

export default (function IPSDTAssetFileExport(props) {

    async function fileDownload() {
        const {projectInfo, station , apiCall , fileStartingName} = props;
        await apiCall(projectInfo, station ,fileStartingName);
    }

    return(
        <FileExportIcon props={props}
        onClick={() => fileDownload()}/>


    )

})